<div class="tab-container">
  @switch (integrationType?.name) {
    @case ('gorgias') {
      <gorgias-settings [integrationType]="integrationType" [integration]="integration"> </gorgias-settings>
    }
    @case ('richpanel') {
      <richpanel-settings [integrationType]="integrationType" [integration]="integration"> </richpanel-settings>
    }
    @case ('triple_whale') {
      <triple-whale-settings [integrationType]="integrationType" [integration]="integration"> </triple-whale-settings>
    }
    @case ('okendo') {
      <okendo-settings [integrationType]="integrationType" [integration]="integration"> </okendo-settings>
    }
    @case ('yotpo') {
      <yotpo-settings [integrationType]="integrationType" [integration]="integration"> </yotpo-settings>
    }
    @case ('judge_me') {
      <judge-me-settings [integrationType]="integrationType" [integration]="integration"> </judge-me-settings>
    }
    @case ('bazaarvoice') {
      <bazaarvoice-settings [integrationType]="integrationType" [integration]="integration"> </bazaarvoice-settings>
    }
    @case ('order_protection') {
      <order-protection-settings [integrationType]="integrationType" [integration]="integration">
      </order-protection-settings>
    }
  }
  @if (integrationType?.metadata?.provideTagsDescription) {
    <div class="feature">
      <p>{{ integrationType?.metadata?.provideTagsDescription }}</p>
      <pdq-slide-toggle
        [disabled]="!integration?.isConnected"
        [defaultValue]="!!integration?.metadata && integration.metadata[PlatformSettingsOption.PROVIDE_TAGS]"
        (onToggle)="handleToggle($event, PlatformSettingsOption.PROVIDE_TAGS)">
      </pdq-slide-toggle>
    </div>
  }
</div>
